import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
export type ChartType = 'bar' | 'donut'

@safeCustomElement('mdc-chart-placeholder-section')
export class MdcChartPlaceholderSection extends LitElement {
  @property({ type: String }) title = ''
  @property({ type: String }) chartType: ChartType = 'bar'

  static styles = css`
    :host {
      display: block;
    }

    .mdc-chart-placeholder-section {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-100, 1rem);
    }

    .mdc-chart-placeholder-section__title {
      font-family: var(--typography-font-family-sans);
      font-size: var(--typography-font-size-112-and-half);
      font-weight: 600;
      line-height: 1.3;
      letter-spacing: -0.00563rem;
      color: var(--color-functional-gray-black);
      margin: 0;
    }

    .mdc-chart-placeholder-section__chart {
      font-family: var(--typography-font-family-sans);
      font-size: var(--typography-font-size-087-and-half);
      font-weight: 450;
      line-height: 1.3;
      min-height: 12rem;
      box-sizing: border-box;
      background-color: var(--color-functional-gray-50);
      border: 1px solid var(--color-functional-gray-200);
      border-radius: var(--radius-md, 0.5rem);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--color-functional-gray-500);
    }
  `

  render() {
    return html`
      <div class="mdc-chart-placeholder-section">
        <h2 class="mdc-chart-placeholder-section__title">${this.title}</h2>
        <div class="mdc-chart-placeholder-section__chart">
          ${this.chartType === 'bar' ? 'Bar chart placeholder' : 'Donut chart placeholder'}
        </div>
      </div>
    `
  }
}
